import SettingsIcon from "@mui/icons-material/Settings";
import PaletteIcon from "@mui/icons-material/Palette";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DevicesOtherIcon from "@mui/icons-material/DevicesOther";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import InventoryIcon from "@mui/icons-material/Inventory";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import CategoryIcon from "@mui/icons-material/Category";
import WidgetsIcon from "@mui/icons-material/Widgets";
import HubIcon from "@mui/icons-material/Hub";
import TranslateIcon from "@mui/icons-material/Translate";
import BuildIcon from "@mui/icons-material/Build";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ConfigSectionBox from "../components/ConfigSectionBox";

const BASE_KEY = "dsokCustomerDetail.sections";

/** User typ constants for visibility rules. */
export const TYP_ADMIN = 1;
export const TYP_PARTNER = 2;
export const TYP_CUSTOMER_USER = 3;
export const TYP_SERVICE_PARTNER = 7;

/** Placeholder: always edit permission. Visibility is controlled by visibleForTyps. */
function getPermissionEditOnly() {
  return "edit";
}

/**
 * @param {string} id - section id
 * @param {string} labelKey - short key for translations (e.g. "customerSettings")
 * @param {boolean} hasDescription - whether section has description key
 * @param {React.Component} icon - MUI icon component
 * @param {number[]} visibleForTyps - user typs that can see this section (1=Admin, 2=Partner, 3=Customer user, 7=Service partner)
 */
function section(id, labelKey, hasDescription, icon, visibleForTyps) {
  return {
    id,
    labelKey: `${BASE_KEY}.${labelKey}.title`,
    descriptionKey: hasDescription ? `${BASE_KEY}.${labelKey}.description` : null,
    icon,
    visibleForTyps,
    getPermission: getPermissionEditOnly,
    component: ConfigSectionBox,
  };
}

// Visibility: Admin (1) = all; Partner (2) & Service partner (7) = devices, colors, products, cart, translations; Customer user (3) = devices
export const customerSettingsSectionConfig = section(
  "customer-settings",
  "customerSettings",
  true,
  SettingsIcon,
  [TYP_ADMIN]
);

export const uiSettingsSectionConfig = section(
  "ui-settings",
  "uiSettings",
  true,
  PaletteIcon,
  [TYP_ADMIN]
);

export const locationsSectionConfig = section(
  "locations",
  "locations",
  true,
  LocationOnIcon,
  [TYP_ADMIN]
);

export const devicesSectionConfig = section(
  "devices",
  "devices",
  true,
  DevicesOtherIcon,
  [TYP_ADMIN, TYP_PARTNER, TYP_CUSTOMER_USER, TYP_SERVICE_PARTNER]
);

export const appSettingsSectionConfig = section(
  "app-settings",
  "appSettings",
  true,
  SettingsApplicationsIcon,
  [TYP_ADMIN]
);

export const colorsSectionConfig = section(
  "colors",
  "colors",
  true,
  ColorLensIcon,
  [TYP_ADMIN, TYP_PARTNER, TYP_SERVICE_PARTNER]
);

export const productsSectionConfig = section(
  "products",
  "products",
  true,
  InventoryIcon,
  [TYP_ADMIN, TYP_PARTNER, TYP_SERVICE_PARTNER]
);

export const cartSectionConfig = section(
  "cart",
  "cart",
  true,
  ShoppingCartIcon,
  [TYP_ADMIN, TYP_PARTNER, TYP_SERVICE_PARTNER]
);

export const categoriesSectionConfig = section(
  "categories",
  "categories",
  true,
  CategoryIcon,
  [TYP_ADMIN]
);

export const dynamicComponentsSectionConfig = section(
  "dynamic-components",
  "dynamicComponents",
  true,
  WidgetsIcon,
  [TYP_ADMIN]
);

export const integrationsSectionConfig = section(
  "integrations",
  "integrations",
  true,
  HubIcon,
  [TYP_ADMIN]
);

export const translationsSectionConfig = section(
  "translations",
  "translations",
  true,
  TranslateIcon,
  [TYP_ADMIN, TYP_PARTNER, TYP_SERVICE_PARTNER]
);

export const maintenanceSectionConfig = section(
  "maintenance",
  "maintenance",
  true,
  BuildIcon,
  [TYP_ADMIN]
);

export const billingSectionConfig = section(
  "billing",
  "billing",
  true,
  ReceiptLongIcon,
  [TYP_ADMIN]
);

export const dsokSectionDefinitions = [
  customerSettingsSectionConfig,
  appSettingsSectionConfig,
  uiSettingsSectionConfig,
  locationsSectionConfig,
  devicesSectionConfig,
  colorsSectionConfig,
  productsSectionConfig,
  cartSectionConfig,
  integrationsSectionConfig,
  translationsSectionConfig,
  categoriesSectionConfig,
  dynamicComponentsSectionConfig,
  maintenanceSectionConfig,
  billingSectionConfig,
];
